<template>
    <div class="uk-width-1-2@m">
        <div class="uk-panel uk-panel-scrollable">
            <div class="uk-overlay uk-position-cover uk-hidden" data-uk-rr-grid-loader>
            </div>
            <div class="uk-child-width-1-1 uk-grid-small" uk-grid data-uk-rr-grid-results>
                <div v-for="item in filteredList">
                    <store-locator-item :item="item"></store-locator-item>
                </div>
            </div>
            <div class="store-locator__load-more" data-uk-rr-grid-load-more></div>
        </div>
    </div>
</template>
<script>
    import StoreLocator from "rubinred/store-locator/js/mixins/StoreLocator";
    export default {
      mixins: [StoreLocator],
      props: {
        stores: {
          type: Array,
          required: true,
        },
      },
      created() {
        let self = this;
        //pass all stores to mixins
        self.allStores = self.stores;
        //on search event add place to queryplace
        this.$root.$on('rubinred.store-locator.search', place => {
          self.queryPlace = place;
        });
      }
    }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/store-locator/assets/js/components/StoreLocatorList.vue